import type { Router } from 'vue-router'

// hash 遷移では index.html を読み直さないため、開きっぱなしのタブは旧ビルドのまま新 API を叩いて壊れる。
// 連続 reload の打ち切りは不要: index.html は no-cache 配信で、reload 後は新しい signature が currentBuild になる

export function setupNewBuildReload(router: Router): void {
  const currentBuild = buildSignature(document)
  let hasNewBuild = false

  async function checkNewBuild() {
    if (hasNewBuild) return
    try {
      const res = await fetch(import.meta.env.BASE_URL, { cache: 'no-store' })
      if (!res.ok) return
      const latest = buildSignature(new DOMParser().parseFromString(await res.text(), 'text/html'))
      if (latest !== currentBuild) hasNewBuild = true
    } catch {
      // オフライン等は次回の check に任せる
    }
  }

  // visibilitychange でなく focus にしているのは、PC でブラウザを表示したまま他アプリと行き来した場合にも発火するため
  window.addEventListener('focus', checkNewBuild)

  router.beforeEach((to, from) => {
    if (!hasNewBuild) return
    // 同じ画面への遷移を行う場合（Queryを更新する場合など）はReloadしない
    if (to.path === from.path) return
    // オフラインで reload するとブラウザのエラー画面になる
    if (!navigator.onLine) return
    // 戻る/進むでは URL が既に遷移先になっている
    if (router.options.history.location !== to.fullPath) {
      router.options.history.push(to.fullPath)
    }
    window.location.reload()
    // false で中断すると、戻る/進むでは router が URL を戻そうとして reload と競合するので、unload まで保留する
    return new Promise<never>(() => {})
  })
}

// entry の module script は content hash 付きで、配下の chunk が 1 つでも変われば名前が変わる
function buildSignature(doc: Document): string {
  return Array.from(doc.querySelectorAll('script[type="module"][src]'), (s) =>
    s.getAttribute('src'),
  ).join(',')
}
